import React from 'react';
import * as logos from '../images/subscription-logos';
import { certifications } from '../../public/static/configs/certificationTypeIdMap.json';

export const certificationLogos: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  [certifications.CHASAdvanced]: logos.CHASAdvancedLogo,
  [certifications.CHASElite]: logos.CHASEliteLogo,
  [certifications.CHASVerifiedSupplier]: logos.CHASVerifiedSupplierLogo,
  [certifications.VerifiedContractor]: logos.CHASVerifiedContractorLogo,
  [certifications.VerifiedSupplier]: logos.CHASVerifiedSupplierLogo,
  [certifications.Elite]: logos.CHASEliteLogo,
  [certifications.CHASStandard]: logos.CHASStandardLogo,
  [certifications.CHASVCS]: logos.CHASVCSLogo,
  [certifications.CHASSocialSustainability]: logos.CHASSocialSustainabilityLogo
};
